/** Email-safe professional signature layout (logo left + contact right). */

const ICONS = {
  phone: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAR0lEQVR42mNgoBAwYhM0dwz8j0vDyf3rUfQwkaKZoLy5Y+B/YgxAVsNEaRiMGjAsDGAhJcWhJ2OquICR1LyA7hImYpyJTx4AB0YbPRF7pE4AAAAASUVORK5CYII=",
  mail: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAX0lEQVR42mNgGPKAkYGBgSF69tX/5GhemqrNyESpC1hwmYxNHJtLmYhViMubTOg2w2yPnn31P0wTsmZ01zER8gI+zTgNwKYYV7gwEYomfJoJGkBIM0Y0kpOgmIZ+ZgIAWUMnvIgHyBMAAAAASUVORK5CYII=",
  globe: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAbUlEQVR42mNgoBAw4pKInn31PzJ/aao2I1EGoGtEB+gGMRGyFV0DTguiZ1/9D5PEpghZDlmeidJAZEI2HVdAYQsDmB4mqkQjoZAnGCPoAYMvENHVM2HzFz6AHl5MVE3KuJIvvmRNcVKmODNRDAATOlWL30vjvQAAAABJRU5ErkJggg==",
  link: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAVElEQVR42mNgGAUYIHr21f/Rs6/+J1aOBVmSFEsYGBgYlqZqM7KgSy5N1WbEpREmh2wZI7qJpLqChZACQq5jokvo41PLgi+EifEWC74QJhQbwwQAAF44OTLVdJgHAAAAAElFTkSuQmCC",
  logoPlaceholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAAwCAYAAADab77TAAAAt0lEQVR42u3csQqDMBSG0eTiW3QQfP9nEhz6BC1ddRJCG0rWXM43Bqccdfzr6/05i9K29A734+lmJmxbHz9nATdPPbva/qLvB3pvguYBbv0Cbr5fdPslB9zcyOFKcgcYsAALsAALsAALMGABFmABFmABFmDAAizAAizAAizAAgxYgAVYgAVYgAUYsAALsAALsABrALg3v6OSYisr/m0saf4htPo9Rgq4pNqrjJFBS807RlrNCefuAp/tOc81YbwSAAAAAElFTkSuQmCC",
};

function iconImg(key, alt = "") {
  const src = ICONS[key];
  return `<img src="${src}" width="14" height="14" alt="${alt}" style="width:14px;height:14px;vertical-align:middle;border:0;display:inline-block;" />`;
}

/** @returns {string} HTML for TipTap / outbound email */
export function buildSignatureLayoutHtml() {
  return `<table data-crm-sig-layout="1" cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif;color:#1f2937;font-size:13px;line-height:1.45;">
  <tbody>
    <tr>
      <td valign="top" style="padding:0 16px 0 0;border:0;vertical-align:top;">
        <img src="${ICONS.logoPlaceholder}" width="120" height="48" alt="Your logo" style="width:120px;height:auto;display:block;border:0;border-radius:6px;" />
      </td>
      <td valign="top" style="padding:0;border:0;vertical-align:top;">
        <p style="margin:0 0 2px;font-size:13px;color:#374151;">Thanks &amp; Regards,</p>
        <p style="margin:0 0 2px;font-size:14px;font-weight:700;color:#111827;"><strong>Your Name</strong></p>
        <p style="margin:0 0 8px;font-size:13px;color:#4b5563;">Your Title</p>
        <p style="margin:0 0 3px;font-size:13px;color:#374151;">${iconImg("phone")}&nbsp;+1 (000) 000-0000</p>
        <p style="margin:0 0 3px;font-size:13px;">${iconImg("mail")}&nbsp;<a href="mailto:you@example.com" style="color:#2563eb;text-decoration:underline;">you@example.com</a></p>
        <p style="margin:0 0 3px;font-size:13px;">${iconImg("globe")}&nbsp;<a href="https://example.com" style="color:#2563eb;text-decoration:underline;">Company tagline</a></p>
        <p style="margin:0;font-size:13px;">${iconImg("link")}&nbsp;<a href="https://example.com" style="color:#2563eb;text-decoration:underline;">Company Inc.</a></p>
      </td>
    </tr>
  </tbody>
</table><p></p>`;
}

export function editorLooksEmpty(html) {
  const t = String(html || "")
    .replace(/<br\s*\/?>/gi, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/<[^>]+>/g, "")
    .trim();
  return !t;
}
